/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import { State } from 'app/gamma/src/modules/types';
import React from 'react';
import { connect } from 'react-redux';
import { isNavigating } from 'app/gamma/src/selectors/ui';
import { forTemplate } from 'app/common/lib/util/i18n';
import styles from './header.less';
import RouterLink from 'app/common/components/singlespa/router-link';

const format = forTemplate('header_back_menu_button');

interface StateProps {
  brandingLogo: string | undefined;
  brandingName: string | undefined;
  isNavigating: boolean;
}

interface Props extends StateProps {
  className?: string;

  // Set to true if we want to full page pop the redirect to '/', which
  // we do in the anonymous header so it takes us to the meta page.
  skipRouter?: boolean;

  isLeftAligned?: boolean;
}

class HeaderLogo extends React.Component<Props> {
  render() {
    const {
      brandingName,
      brandingLogo,
      className,
      isLeftAligned,
      skipRouter,
    } = this.props;
    const classes = classNames(
      styles.logo,
      className,
      isLeftAligned && styles.narrowScreen,
      this.props.isNavigating && styles.throbbing,
      brandingLogo && !brandingName && styles.branded,
      brandingName && styles.corporateVis,
    );

    const logo = (
      <>
        <div className={styles.logoContainer}>
          {brandingLogo && (
            <img
              className={styles.brandingLogo}
              src={brandingLogo}
              alt=""
              role="presentation"
            />
          )}
          <span className={styles.loadingLogo} />
          <span className={styles.defaultLogo} />
        </div>
        <div className={styles.brandingName}>{brandingName}</div>
      </>
    );

    return skipRouter ? (
      <a href="/" className={classes} aria-label={format('backToHome')}>
        {logo}
      </a>
    ) : (
      <RouterLink
        href="/"
        className={classes}
        aria-label={format('backToHome')}
      >
        {logo}
      </RouterLink>
    );
  }
}

function mapStateToProps(state: State) {
  return {
    brandingLogo: state.ui.header.brandingLogo,
    brandingName: state.ui.header.brandingName,
    isNavigating: isNavigating(state),
  };
}

export default connect(mapStateToProps)(HeaderLogo);
